import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Col,
  Row,
  message,
  InputNumber,
  DatePicker,
  Button,
} from "antd";
import {
  API_METHODS,
  BLANK_VALUE,
  DEFAULT_DATE_FORMAT,
} from "../../../constants";
import useApi from "../../../hooks/useApi";
import {
  formatDateToDayJS,
  isEmpty,
  replaceBlankValueToUndefined,
} from "../../../generalFunctions";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import AddReleaseOrder from "../../config/release order/AddReleaseOrder";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

function AddPublicationBill() {
  const location = useLocation();

  const [form] = Form.useForm();
  const [billData, getBillData] = useApi(
    "/publicationBill/",
    null,
    API_METHODS.GET
  );
  const [response, request] = useApi(
    "/publicationBill",
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    "/publicationBill",
    null,
    API_METHODS.POST
  );

  const [selectedRO, setSelectedRO] = useState();
  const [loadingSaveButton, setLoadingSaveButton] = useState(false);
  const [singleGetResponse, singleGetRequest] = useApi(
    `/releaseOrder/publicationBill`,
    null,
    API_METHODS.GET
  );
  const [isBillEditable, setIsBillEditable] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    let initialValues = billData && billData.data && billData.data[0];
    if (initialValues) {
      if (
        location.state.isViewOnly === false &&
        initialValues.billAmount !== initialValues.balanceAmount
      ) {
        setIsBillEditable(false);
        message.error(
          "You can not edit the publication bill.Billwise payment is alredy done"
        );
      }
      initialValues = replaceBlankValueToUndefined(initialValues);
      initialValues.entryDate = formatDateToDayJS(initialValues.entryDate);
      initialValues.billDate = formatDateToDayJS(initialValues.billDate);
      form.setFieldsValue(initialValues);
      setSelectedRO(initialValues.roData[0]);
    } else if (billData.error) {
      navigate("/portal/publicationBill");
    }
  }, [billData]);

  useEffect(() => {
    if (
      singleGetResponse &&
      !isEmpty(singleGetResponse.data) &&
      !singleGetResponse.isLoading
    ) {
      const { data } = singleGetResponse;
      setSelectedRO(data[0]);
    } else if (
      singleGetResponse &&
      singleGetResponse.data === BLANK_VALUE &&
      !singleGetResponse.isLoading
    ) {
      message.error(
        "Publication bill is already done or No Release Order found."
      );
    }
  }, [singleGetResponse]);

  useEffect(() => {
    if (response.data) {
      message.success("Publication Bill added successfully.");
      setLoadingSaveButton(false);
      navigate("/portal/publicationBill");
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      message.success("Publication Bill updated successfully.");
      setLoadingSaveButton(false);
      navigate("/portal/publicationBill");
    }
  }, [editResponse]);

  useEffect(() => {
    if (location.state && location.state.bill_id) {
      getBillData(
        null,
        API_METHODS.GET,
        `/publicationBill/${location.state.bill_id}`
      );
    }
  }, [location.state]);

  const basicAmountChanged = () => {
    const { basicAmount, cgstRate, sgstRate, igstRate } = form.getFieldsValue();

    let cgst = Math.round(((basicAmount * cgstRate) / 100) * 1e2) / 1e2;
    let sgst = Math.round(((basicAmount * sgstRate) / 100) * 1e2) / 1e2;
    let igst = Math.round(((basicAmount * igstRate) / 100) * 1e2) / 1e2;

    let billAmount = basicAmount + cgst + sgst + igst;

    form.setFieldsValue({
      cgst,
      sgst,
      igst,
      billAmount: Math.round(billAmount),
    });
  };

  const cgstRateChanged = () => {
    const { basicAmount, cgstRate, sgst, igst } = form.getFieldsValue();
    let cgst = Math.round(((basicAmount * cgstRate) / 100) * 1e2) / 1e2;
    let billAmount = basicAmount + cgst + sgst + igst;
    form.setFieldsValue({
      cgst,
      billAmount: Math.round(billAmount),
    });
  };
  const sgstRateChanged = () => {
    const { basicAmount, cgst, sgstRate, igst } = form.getFieldsValue();
    let sgst = Math.round(((basicAmount * sgstRate) / 100) * 1e2) / 1e2;
    let billAmount = basicAmount + cgst + sgst + igst;
    form.setFieldsValue({
      sgst,
      billAmount: Math.round(billAmount),
    });
  };
  const igstRateChanged = () => {
    const { basicAmount, cgst, sgst, igstRate } = form.getFieldsValue();
    let igst = Math.round(((basicAmount * igstRate) / 100) * 1e2) / 1e2;
    let billAmount = basicAmount + cgst + sgst + igst;
    form.setFieldsValue({
      igst,
      billAmount: Math.round(billAmount),
    });
  };

  const previousButtonClicked = () => {
    let bill_id = form.getFieldValue("id") - 1;
    getBillData(null, API_METHODS.GET, `/publicationBill/${bill_id}`);
  };
  const nextButtonClicked = () => {
    let bill_id = form.getFieldValue("id") + 1;
    getBillData(null, API_METHODS.GET, `/publicationBill/${bill_id}`);
  };

  const onFinish = () => {
    form.validateFields().then((values) => {
      if (!loadingSaveButton) {
        if (isEmpty(selectedRO)) {
          message.error("Please add Release Order");
          return false;
        }
        setLoadingSaveButton(true);
        values.roId = selectedRO.id;
        values.roDate = selectedRO.roDate;
        values.publicationId = selectedRO.publicationId;
        values.isClassified = selectedRO.isClassified;

        //delete values.roAmount;
        if (location && location.state) {
          values.entryDate = formatDateToDayJS(values.entryDate);
          values.billDate = formatDateToDayJS(values.billDate);
          editRequest(
            values,
            API_METHODS.PUT,
            `/publicationBill/${location.state.bill_id}`
          );
        } else {
          request(values, API_METHODS.POST);
        }
      }
    });
  };

  const onReleaseOrderSearch = (id) => {
    if (!isEmpty(id))
      singleGetRequest(
        null,
        API_METHODS.GET,
        `/releaseOrder/publicationBill/${id}`
      );
  };

  const isFormDisabled = () => {
    let disabled = true;
    if (isBillEditable && !location.state.isViewOnly) {
      disabled = false;
    }
    return disabled;
  };

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          entryDate: dayjs(),
          cgstRate: 2.5,
          sgstRate: 2.5,
          igstRate: 0,
          igst: 0,
        }}
        onFinish={onFinish}
        disabled={location && location.state && isFormDisabled()}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="id" label="Entry Number">
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="entryDate"
              label="Entry Date"
              rules={[{ required: true, message: "Entry Date is required." }]}
            >
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="billDate"
              label="Bill Date"
              rules={[{ required: true, message: "Bill Date is required." }]}
            >
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="billNumber"
              label="Bill Number"
              rules={[
                { required: true, message: "Bill Number is required." },
                {
                  max: 200,
                  message: "Bill Number should be maximum of 200 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Input.Search
              prefix="RO-"
              placeholder="Release Order Number"
              allowClear
              enterButton="Search"
              onSearch={onReleaseOrderSearch}
            />
          </Col>
        </Row>

        {selectedRO && (
          <div>
            <AddReleaseOrder
              selectedRecord={selectedRO}
              isViewOnly={true}
              isViewModal={false}
            />
            <Col span={8}>
              <Form.Item label="RO Amount">
                <InputNumber disabled={true} value={selectedRO.roAmount} />
              </Form.Item>
            </Col>
          </div>
        )}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="basicAmount"
              label="Basic Amount"
              onChange={() => basicAmountChanged()}
              rules={[{ required: true, message: "Basic Amount is required." }]}
            >
              <InputNumber />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="cgstRate" label="CGST %">
              <InputNumber onChange={() => cgstRateChanged()} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="cgst" label="CGST Rs.">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="sgstRate" label="SGST %">
              <InputNumber onChange={() => sgstRateChanged()} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="sgst" label="SGST Rs.">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="igstRate" label="IGST %">
              <InputNumber onChange={() => igstRateChanged()} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="igst" label="IGST Rs.">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="billAmount" label="Bill Amount">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingSaveButton}
              >
                Save
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => {
                navigate("/portal/publicationBill");
              }}
              disabled={false}
            >
              {location && location.state && location.state.isViewOnly
                ? "Close"
                : "Cancel"}
            </Button>
          </Col>
        </Row>
      </Form>
      {location && location.state && location.state.isViewOnly && (
        <Row justify="space-between">
          <Button type="primary" onClick={previousButtonClicked}>
            <LeftOutlined />
            Previous
          </Button>
          <Button type="primary" onClick={nextButtonClicked}>
            Next
            <RightOutlined />
          </Button>
        </Row>
      )}
    </div>
  );
}

export default AddPublicationBill;
